/* ============================================================
   Bundle in cart — keep the "7 for $85" bundle atomic.

   1) Clicking "Remove" on a bundle parent (data-bundle-remove="<bundleId>")
      deletes the $85 parent AND all its pieces (same _bundleId) in one call.
   2) SAFETY NET: a self-healing pass removes any orphan bundle PIECES whose
      parent is no longer in the cart. So even if the parent gets removed by
      the theme's single-line remove (or any other path), the 7 pieces can
      never "spill out" at full price — they're cleaned up automatically.
   ============================================================ */
(function () {
  'use strict';

  function refreshCart() {
    // Cart PAGE (<cart-items> present): the total lives in a SEPARATE section
    // (#main-cart-footer) that onCartUpdate never re-renders, and the empty-cart
    // markup sits OUTSIDE <cart-items> — so partial updates leave the total (and
    // empty state) stale. An automatic reload syncs items + total + empty state
    // in one shot, which is exactly the "extra refresh" the user was doing by hand.
    if (document.querySelector('cart-items')) {
      window.location.reload();
      return;
    }

    // Drawer context: onCartUpdate re-renders the items AND the drawer footer
    // (total) together, so this stays smooth (no reload).
    var drawer = document.querySelector('cart-drawer-items');
    if (drawer && typeof drawer.onCartUpdate === 'function') {
      try { drawer.onCartUpdate(); } catch (e) { window.location.reload(); return; }
    } else {
      window.location.reload();
      return;
    }
    try { document.dispatchEvent(new CustomEvent('cart:refresh')); } catch (e) {}
  }

  function postUpdates(updates) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    });
  }

  // Remove the whole bundle (parent + every piece sharing its _bundleId).
  async function removeBundle(bundleId) {
    try {
      var cart = await (await fetch('/cart.js')).json();
      var updates = {};
      cart.items.forEach(function (it) {
        if (it.properties && it.properties._bundleId === bundleId) updates[it.key] = 0;
      });
      if (!Object.keys(updates).length) { refreshCart(); return; }
      await postUpdates(updates);
      refreshCart();
    } catch (e) {
      window.location.reload();
    }
  }

  // Safety net: drop any bundle PIECE whose parent is missing from the cart.
  var cleaning = false;
  async function cleanupOrphanPieces() {
    if (cleaning) return;
    cleaning = true;
    try {
      var cart = await (await fetch('/cart.js')).json();
      var parents = {};
      cart.items.forEach(function (it) {
        var p = it.properties || {};
        if (p._bundleType === 'Parent Bundle' && p._bundleId) parents[p._bundleId] = true;
      });
      var updates = {};
      cart.items.forEach(function (it) {
        var p = it.properties || {};
        if (p._bundleType === 'Bundle Item' && p._bundleId && !parents[p._bundleId]) {
          updates[it.key] = 0;
        }
      });
      if (Object.keys(updates).length) {
        await postUpdates(updates);
        refreshCart();
      }
    } catch (e) {
      /* leave the cart as-is on error */
    } finally {
      cleaning = false;
    }
  }

  // Capture phase: intercept the bundle parent's remove before the theme's
  // single-line cart-remove-button / anchor, so the whole bundle goes at once.
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('[data-bundle-remove]');
    if (!btn) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    removeBundle(btn.getAttribute('data-bundle-remove'));
  }, true);

  // Run the safety net now, and again whenever a cart container re-renders
  // (e.g. after a single-line removal that orphaned the pieces).
  function watchCart() {
    var containers = document.querySelectorAll('cart-items, cart-drawer-items');
    if (!containers.length) return;
    var t;
    var obs = new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(cleanupOrphanPieces, 120);
    });
    containers.forEach(function (c) {
      obs.observe(c, { childList: true, subtree: true });
    });
  }

  function init() {
    cleanupOrphanPieces();
    watchCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
